import { Tooltip } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { PresentmentDashboard } from 'api/nach';
import moment from 'moment';

function getFullDate(date: string) {
  if (date != null) {
    let dateMoment = moment(new Date(date)).format('DD/MM/YYYY HH:mm:ss');
    return dateMoment;
  }
}

function geTxnDate(date: string) {
  if (date != null) {
    let dateMoment = moment(new Date(date)).format('DD/MM/YYYY');
    return dateMoment;
  }
}

export const FilterColumns: ColumnsType<PresentmentDashboard> = [
  {
    key: 'umrnNO',
    title: 'UMRN NO',
    dataIndex: 'umrnNO',
    fixed: 'left',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'corporateName',
    title: 'Corporate Name',
    dataIndex: 'corporateName',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'corporateUserNo',
    title: 'Corporate User No',
    dataIndex: 'corporateUserNo',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },

  {
    key: 'amount',
    title: 'Amount',
    dataIndex: 'amount',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'transactionIDREF',
    title: 'Transaction ID REF',
    dataIndex: 'transactionIDREF',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },

  {
    key: 'uniqueReference',
    title: 'Unique Reference',
    dataIndex: 'uniqueReference',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'batchNo',
    title: 'Batch No',
    dataIndex: 'batchNo',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },

  {
    key: 'createdOn',
    title: 'Created On',
    dataIndex: 'createdOn',
    ellipsis: true,
    align: 'center',
    render: (date: string) => getFullDate(date),
  },
  {
    key: 'customerDebitAC',
    title: 'Customer Debit AC',
    dataIndex: 'customerDebitAC',
    ellipsis: true,
    width: 1000,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'customerMICR',
    title: 'Customer MICR',
    dataIndex: 'customerMICR',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'dateOfTxn',
    title: 'Date of Transaction',
    dataIndex: 'dateOfTxn',
    ellipsis: true,
    align: 'center',
    render: (date: string) => geTxnDate(date),
  },
  {
    key: 'debtorName',
    title: 'Debitor Name',
    dataIndex: 'debtorName',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'ifsc',
    title: 'IFSC',
    dataIndex: 'ifsc',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'loanType',
    title: 'Loan Type',
    dataIndex: 'loanType',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'merchantOrderId',
    title: 'Merchant Order ID',
    dataIndex: 'merchantOrderId',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'merchantSubscriptionId',
    title: 'Merchant Subscription ID',
    dataIndex: 'merchantSubscriptionId',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'notificationDate',
    title: 'Notification Date',
    dataIndex: 'notificationDate',
    ellipsis: true,
    align: 'center',
    render: (date: string) => getFullDate(date),
  },
  {
    key: 'notifyResponseOrderID',
    title: 'Notify Response Order ID',
    dataIndex: 'notifyResponseOrderID',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'partnerBank',
    title: 'Partner Bank',
    dataIndex: 'partnerBank',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'preNotificationStatus',
    title: 'Pre Notification Status',
    dataIndex: 'preNotificationStatus',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'presentmentFlag',
    title: 'Presentment Flag',
    dataIndex: 'presentmentFlag',
    ellipsis: true,
    align: 'center',
  },
  {
    key: 'presentmentId',
    title: 'Presentment ID',
    dataIndex: 'presentmentId',
    ellipsis: true,
    align: 'center',
  },
  // {
  //   key: 'presentmentSource',
  //   title: 'Presentment Source',
  //   dataIndex: 'presentmentSource',
  //   ellipsis: true,
  //   align: 'center',
  //   render: (record) => (
  //     <Tooltip placement="topLeft" title={record}>
  //       {record}
  //     </Tooltip>
  //   ),
  // },

  {
    key: 'presentmentStatus',
    title: 'Presentment Status',
    dataIndex: 'presentmentStatus',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'sourcingType',
    title: 'Sourcing Type',
    dataIndex: 'sourcingType',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'errorCode',
    title: 'Error Code',
    dataIndex: 'errorCode',
    ellipsis: true,
    align: 'center',
  },
  {
    key: 'userName',
    title: 'Created By',
    dataIndex: 'userName',
    ellipsis: true,
    align: 'center',
  },
  // {
  //   key: 'active',
  //   title: 'Active',
  //   dataIndex: 'active',
  //   ellipsis: true,
  //   align: 'center',
  //   render: (record) => (
  //     <Tooltip placement="topLeft" title={String(record)}>
  //       {String(record)}
  //     </Tooltip>
  //   ),
  // },
];

export default FilterColumns;
